import { useId, type ReactNode } from "react";
import sharedStorage from "@/assets/app-binding-modes/shared-storage.webp";
import attachmentCompatible from "@/assets/app-binding-modes/attachment-compatible.webp";
import { APP_BINDING_MODE_META, type AppBindingModeId } from "./app-binding-ux";

const illustrations = {
  shared_storage: sharedStorage,
  attachment_compatible: attachmentCompatible,
};
const headlines = {
  shared_storage: "社内の共有ファイルを、そのままkintoneに添付",
  attachment_compatible: "いつもの添付操作で、ファイル管理はおまかせ",
};

export function AppBindingModeSelector({ value, onChange, disabled = false, legendPrefix }: {
  value: AppBindingModeId | "";
  onChange: (mode: AppBindingModeId) => void;
  disabled?: boolean;
  legendPrefix?: ReactNode;
}) {
  const id = useId();
  return (
    <fieldset disabled={disabled} className="min-w-0 space-y-3">
      <legend className="text-sm font-medium"><span className="flex items-center gap-2">{legendPrefix}利用モード</span></legend>
      <p className="text-sm text-muted-foreground">使い方に合わせて、どちらかを選択してください。</p>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,320px),1fr))] gap-4">
        {APP_BINDING_MODE_META.map((mode) => (
          <label key={mode.modeId} className={`relative flex min-w-0 cursor-pointer flex-col rounded-xl border bg-background p-4 shadow-sm transition-all duration-150 focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2 ${disabled ? "cursor-not-allowed opacity-60" : "select-none hover:-translate-y-0.5 hover:border-primary hover:shadow-md active:translate-y-px"} ${value === mode.modeId ? "border-primary ring-1 ring-primary" : "border-border"}`}>
            <span className="flex flex-wrap items-center gap-2">
              <input type="radio" name={id} value={mode.modeId} checked={value === mode.modeId} onChange={() => onChange(mode.modeId)} aria-labelledby={`${id}-${mode.modeId}`} aria-describedby={`${id}-${mode.modeId}-description`} className="h-4 w-4 shrink-0 accent-primary" />
              <span id={`${id}-${mode.modeId}`} className="text-base font-semibold">{mode.label}</span>
              {mode.modeId === "shared_storage" && <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-900">おすすめ</span>}
            </span>
            <span className="mt-3 text-sm font-medium leading-relaxed">{headlines[mode.modeId]}</span>
            <img src={illustrations[mode.modeId]} alt="" width={648} height={532} className="mx-auto my-4 h-auto w-full max-w-[440px] rounded-md" />
            <span id={`${id}-${mode.modeId}-description`} className="mt-auto text-sm leading-relaxed text-muted-foreground">{mode.description}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
